module.exports = __webpack_public_path__ + "static/media/Vector2.c761cd16.svg";